module.exports = __webpack_public_path__ + "img/book.5d38c9d0.svg";